import { useTranslation } from 'react-i18next';

export default function Povracaj() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center cursor-pointer">
              <a href="/" className="flex items-center">
                <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-parking-line text-white text-xl"></i>
                </div>
                <span className="text-xl font-bold text-gray-900">ParkGuard</span>
              </a>
            </div>
            <nav className="hidden md:flex items-center space-x-8">
              <a href="/" className="text-gray-600 hover:text-blue-600 transition-colors font-medium">Početna</a>
              <a href="/#features" className="text-gray-600 hover:text-blue-600 transition-colors font-medium">Proizvod</a>
              <a href="/#faq" className="text-gray-600 hover:text-blue-600 transition-colors font-medium">Česta pitanja</a>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-green-50 to-blue-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center bg-green-100 text-green-600 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-refresh-line mr-2"></i>Povraćaj novca
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            30 dana garancije povraćaja novca
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Niste zadovoljni? Bez problema! Vratite proizvod u roku od 30 dana i dobijte pun povraćaj novca
          </p>
        </div>
      </section>

      {/* Return Policy Details */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-calendar-line text-green-600 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">30 dana</h3>
              <p className="text-gray-600">Rok za povraćaj proizvoda</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-truck-line text-blue-600 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Povratna dostava</h3>
              <p className="text-gray-600">Platite samo troškove povrata</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-money-dollar-circle-line text-purple-600 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">100%</h3>
              <p className="text-gray-600">Povraćaj novca</p>
            </div>
          </div>

          <div className="space-y-8">
            <div className="bg-gray-50 rounded-2xl p-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Kako funkcioniše povraćaj?</h2>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                <div className="text-center">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-blue-600 font-bold">1</span>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">Kontaktirajte nas</h4>
                  <p className="text-gray-600 text-sm">Pozovite ili pošaljite email sa zahtevom za povraćaj</p>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-green-600 font-bold">2</span>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">Dobijte instrukcije</h4>
                  <p className="text-gray-600 text-sm">Poslać emo vam instrukcije i etiketu za povratnu dostavu</p>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-purple-600 font-bold">3</span>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">Pošaljite proizvod</h4>
                  <p className="text-gray-600 text-sm">Zapakujte proizvod i pošaljite kurirskoj službi</p>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-orange-600 font-bold">4</span>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">Dobijte novac</h4>
                  <p className="text-gray-600 text-sm">Novac će biti vraćen u roku od 3-5 radnih dana</p>
                </div>
              </div>
            </div>

            <div className="bg-blue-50 rounded-2xl p-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Uslovi za povraćaj</h2>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <i className="ri-check-line text-green-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900">Rok od 30 dana</h4>
                    <p className="text-gray-600">Proizvod mora biti vraćen u roku od 30 dana od datuma kupovine.</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-check-line text-green-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900">Originalno pakovanje</h4>
                    <p className="text-gray-600">Proizvod mora biti u originalnom pakovanju sa svim priborom.</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-check-line text-green-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900">Dobro stanje</h4>
                    <p className="text-gray-600">Proizvod mora biti u dobrom stanju bez oštećenja.</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-check-line text-green-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900">Račun o kupovini</h4>
                    <p className="text-gray-600">Potreban je originalni račun ili potvrda o kupovini.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-yellow-50 rounded-2xl p-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Važne napomene</h2>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <i className="ri-information-line text-yellow-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900">Troškovi povratne dostave</h4>
                    <p className="text-gray-600">Troškove povratne dostave snosi kupac prema cenovniku kurirske službe.</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-information-line text-yellow-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900">Brza obrada</h4>
                    <p className="text-gray-600">Povraćaj novca se obrađuje u roku od 24-48 sati nakon prijema proizvoda.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-green-50 to-blue-50 rounded-2xl p-8 border border-green-200">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Razlozi za povraćaj</h2>
              <p className="text-gray-600 mb-6">Možete vratiti proizvod iz bilo kog razloga, bez objašnjenja. Evo najčešćih razloga:</p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="space-y-3">
                  <div className="flex items-center space-x-3">
                    <i className="ri-check-line text-green-600"></i>
                    <span className="text-gray-700">Proizvod ne odgovara očekivanjima</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <i className="ri-check-line text-green-600"></i>
                    <span className="text-gray-700">Tehnički problemi</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <i className="ri-check-line text-green-600"></i>
                    <span className="text-gray-700">Nekompatibilnost sa parking mestom</span>
                  </div>
                </div>
                <div className="space-y-3">
                  <div className="flex items-center space-x-3">
                    <i className="ri-check-line text-green-600"></i>
                    <span className="text-gray-700">Promena mišljenja</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <i className="ri-check-line text-green-600"></i>
                    <span className="text-gray-700">Oštećenje tokom transporta</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <i className="ri-check-line text-green-600"></i>
                    <span className="text-gray-700">Bilo koji drugi razlog</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="text-center">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Želite da vratite proizvod?</h2>
              <p className="text-gray-600 mb-8">Kontaktirajte nas i pokrenućemo proces povraćaja odmah</p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a 
                  href="tel:+381612929053"
                  onClick={() => {
                    if (typeof window !== 'undefined') {
                      window.dataLayer = window.dataLayer || [];
                      window.dataLayer.push({ event: 'contact_click', method: 'phone' });
                    }
                  }}
                  className="bg-blue-600 text-white px-8 py-3 rounded-xl hover:bg-blue-700 transition-colors font-medium"
                >
                  <i className="ri-phone-line mr-2"></i>061 29 29 053
                </a>
                <a 
                  href="mailto:povracaj@parkguard.rs"
                  className="bg-white text-blue-600 border border-blue-600 px-8 py-3 rounded-xl hover:bg-blue-50 transition-colors font-medium"
                >
                  <i className="ri-mail-line mr-2"></i>povracaj@parkguard.rs
                </a>
              </div>
            </div>

            <div className="bg-gray-900 text-white rounded-2xl p-8 text-center">
              <h3 className="text-xl font-bold mb-4">Naša obećanja</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div>
                  <i className="ri-shield-check-line text-green-400 text-2xl mb-2"></i>
                  <p className="text-sm">Bez skrivenih troškova</p>
                </div>
                <div>
                  <i className="ri-time-line text-blue-400 text-2xl mb-2"></i>
                  <p className="text-sm">Brza obrada zahteva</p>
                </div>
                <div>
                  <i className="ri-customer-service-line text-purple-400 text-2xl mb-2"></i>
                  <p className="text-sm">Prijateljska podrška</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="text-center">
            <div className="flex items-center justify-center mb-4">
              <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center mr-3">
                <i className="ri-parking-line text-white text-xl"></i>
              </div>
              <span className="text-xl font-bold">ParkGuard</span>
            </div>
            <p className="text-gray-400 mb-6">
              Pametna rešenja za zaštićeno parkiranje. Vaše parking mesto, vaša kontrola.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
